/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.publicQrCodeScan.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class ScanPublicQrCodeRequest(
    @SerialName("business_id")
    val businessId: String,

    @SerialName("token")
    val token: String,

    @SerialName("recaptcha_token")
    val recaptchaToken: String,

    @SerialName("platform_id")
    val platformId: Int
)
